import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreateServiceOrdreComponentDialogData } from 'src/app/components/aftale/models';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { KreditvurderingDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kreditvurdering-dto';
import { KreditvaerdigEnumDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kreditvaerdig-enum-dto';
@Component({
    selector: 'app-kreditvurdering-dialog',
    templateUrl: './kreditvurdering-dialog.component.html',
    styleUrls: ['./kreditvurdering-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KreditvurderingDialogComponent {
  kreditvaerdigEnum = KreditvaerdigEnumDto;
  kreditvurdering: KreditvurderingDto;
  buttonText?: string;

  serviceaftale: ServiceaftaleDto;
  constructor(
    public dialogRef: MatDialogRef<KreditvurderingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateServiceOrdreComponentDialogData,
  ) {
    this.serviceaftale = data.serviceaftale;
    this.kreditvurdering = data.kreditvurdering;
    this.kreditvaerdigEnum;
    this.buttonText = data.buttonText;
  }

  accept() {
    this.dialogRef.close(true);
  }
}
